<template>
  <div class="btn-group" >
    {{ title }}
    <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none no-line-height" no-caret >
      <template v-slot:button-content>
        <i class="fa fa-filter" :class="{ 'text-muted': !keyword }"></i>
      </template>
      <b-dropdown-form  @submit.stop.prevent>
        <b-form-group class="form-group-override" label-for="dropdown-form-search">
          <b-form-input
            id="dropdown-form-search-field"
            size="sm"
            :placeholder="'Search '+field+'...'"
            ref="input"
            v-model="keyword" 
            @keyup="search"
          ></b-form-input>
          <span class="note_font">*use ' , ' for multiple search</span>
        </b-form-group>
        <!-- <b-button class="btn btn-default fa fa-search" variant="primary" size="sm" @click="search">Search</b-button> -->
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  props: ['field', 'title', 'query'],
  data: () => ({
    keyword: ''
  }),
  mounted () {
    $(this.$el).on('shown.bs.dropdown', e => this.$refs.input.focus())
  },
  watch: {
    keyword (kw) {
      // reset immediately if empty
      if (kw === '') this.search()
    }
  },
  methods: {
    search () {
      const { query } = this
      // `$props.query` would be initialized to `{ limit: 10, offset: 0, sort: '', order: '' }` by default
      // custom query conditions must be set to observable by using `Vue.set / $vm.$set`
      if(this.keyword) this.$set(query, this.field, this.keyword)
      else this.$delete(query, this.field)
      query.offset = 0 // reset pagination
    }
  }
}
</script>
<style>
input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
  cursor: pointer;
}
.no-line-height{
  line-height: 0 !important;
  padding: 0 5px !important;
}
.form-group-override{
  padding:5px;
  margin-bottom:0px !important;
}
.note_font{
  font-size: 8px;
}
.dropdown-menu.show{
  top: 1.2rem !important;
}
</style>
